goog.provide('el8.appservice.websocket');

goog.require('el8.appservice.realtime');
goog.require('el8.service.intervals');
goog.require('el8.template.service.status');
goog.require('el8.service.pageunload');

// FUTURE - see how we can get rid of these explicit lists? Too many moving
// parts needed to get realtime updates working for a given entity/data type

// Patient related classes
var patientChartClasses = [
  'CareTeamPhysicianParticipation',
  'CareTeamPracticeParticipation',
  'CarequalityData',
  'CarequalityXmlSummary',
  'ChecklistTemplate',
  'ClinicalFormCollection', // should check by patient id
  'DocumentReminderNotification', // Should check by patient id
  'LabOrder', // Should check by patient id
  'LabOrderSet', // Maybe?
  'Letter',
  'LetterTemplate',
  'MedOrder', // Should check by patient id
  'MessageThread', // Should check by patient id
  'Patient', // Should check by patient id
  'PatientAllergy', // Should check by patient id
  'PatientDrugIntolerance', // should check by patient id
  'PatientFamilyRelationship',
  'PatientHistoryItem', // should check by patient id
  'PatientInsuranceCardImage',
  'PatientMaintenanceItem', // should check by patient id
  'PatientProblem',  // should check by patient id
  'PatientProviderTeamMember', // Maybe?
  'PatientSmokingStatus',
  'PracticeReportType',
  'PracticeSettings',
  'PrenatalFlowsheet', // Should check by patient id
  'PrenatalFlowsheetVisitMeasurements', // Should check by patient id
  'RxHistoryDownloadSummary', // Check if we need to update react part as well
  'ScribingSession',
  'ServiceLocation',
  'StaffGroup', // Maybe?
  'VisitNote', // Should check by patient id
  'VisitNote2',
  'VisitNoteBullet', // should check by patient id
  'VisitNoteType', // Should check by patient id

    // Not real model classes, used specifically to create a deviation from 'Patient'
  'PatientDemographics',
  'DecisionSupports'
];

// Practice home related classes
var practiceHomeClasses = [
  'UploadedImage',
  'UploadedFile',
  'IncomingFileGroup',
  'Appointment',
  'RecurringEventSchedule',
  'AppointmentType',
  'AppointmentRoom',
  'StaffGroup', // Maybe?

  // Not a real model class, used specifically to create a deviation from 'Patient'
  'PatientDemographics'
];

// Practice settings
var practiceSettingsClasses = [
  'AppointmentType',
  'PracticeSettings',
  'AppointmentRoom',
  'ChecklistTemplate', // Templates
  'ESignature',
  'LetterTemplate', // Templates
  'ServiceLocation',
  'StaffGroup', // Maybe?
  'LetterRoutingRule'
];

// FUTURE: Do we need to subscribe to 'ServiceLocation' updates in Billing Home?
// Billing Home related classes (Bill, Visit, Patient, ServiceLocation)
var billingHomeClasses = [
  'PatientDemographics',
  'VisitNote' // Currently, both bill and visit note updates are associated to the VisitNote
];

var onboardingClasses = [
  'ESignature'
]

/**
 * Helper to check if realtime update is supported for the given page, class, etc.
 * @param {*} message Realtime notification message
 * @param {string} testName Test if message is for the current el8Globals.APP
 * @param {string[]} testClasses Test if message.document_type is in this list
 * @param {boolean} shouldCheckPatientId Test if message is for the current patient
 */
function isSupportedMessage(message, testName, testClasses, shouldCheckPatientId) {
  var mClass = message.document_type;
  var patientId = message.patient_id;
  if (el8Globals.APP !== testName) return false;
  if (testClasses.indexOf(mClass) === -1) return false;
  if (shouldCheckPatientId && patientId && patientId !== el8Globals.PATIENT_ID) return false;
  return true;
}

/**
 * Check if current page/app supports realtime updates for given message
 */
function shouldProcessMessage(message) {
  var mClass = message.document_type;
  if (!mClass) {
    return false;
  }

  return isSupportedMessage(message, 'home', practiceHomeClasses, false) ||
    isSupportedMessage(message, 'settings', practiceSettingsClasses, false) ||
    isSupportedMessage(message, 'chart', patientChartClasses, true) ||
    isSupportedMessage(message, 'billing_home', billingHomeClasses, false) ||
    isSupportedMessage(message, 'onboarding', onboardingClasses, false); 
};

var MAX_CONNECTION_ATTEMPTS = 3;
var FAILED_CONNECTION_TIMEOUT = 1000 * 60 * 3; // 3 minutes

/**
 * Web socket connection is responsible for 'realtime' data updates.
 */
el8.appservice.websocket = (function() {

    /**
     * Private state variables
     */
    var socket = null;
    var isWebSocketOpen = false;
    var isConnectingToWebSocket = false;

    var connectionAttempts = 0;
    var connectionInterval = null;
    var noConnectionFlag = false;
    var noConnectionElt = null;

    return {
        startWebsocket: function() {
          if (!isWebSocketOpen) {
            socket = new WebSocket(el8Globals.WEBSOCKETS_URL + '?token=' + el8Globals.WEBSOCKETS_TOKEN);
            isConnectingToWebSocket = true;

            socket.onopen = el8.appservice.websocket.handleWebsocketOpen;
            socket.onmessage = el8.appservice.websocket.handleWebsocketMessage;
            socket.onclose = el8.appservice.websocket.handleWebsocketClose;
            socket.onerror = el8.appservice.websocket.handleWebsocketError;
          }
        },

        handleWebsocketOpen: function() {
          isWebSocketOpen = true;
          isConnectingToWebSocket = false;
          connectionAttempts = 0;

          if (connectionInterval) {
            $.el8_clearTimeout(connectionInterval);
            connectionInterval = null;
          }
          el8.appservice.websocket.hideConnectionAlert();

          el8.service.pageunload.add(function() {
              if (socket) {
                socket.close(4000, 'Page closed');
              }
          }, false)
        },

        handleWebsocketMessage: function(event) {
          try {
            var message = JSON.parse(event.data);

            if (shouldProcessMessage(message)) {
              el8.appservice.realtime.queueMessages([message]);
            }
          } catch(err) {
            console.error('There was an error processing message' + event.data, err);
          }
        },

        handleWebsocketClose: function(event) {
          socket = null;
          isWebSocketOpen = false;
          isConnectingToWebSocket = false;

          // Do not try to reconnect if the user closes page
          if (event.code === 4000) return;

          if (connectionAttempts < MAX_CONNECTION_ATTEMPTS) {
            /**
             * After we failed to connect to websockets we try to reconnect in 1 second and then
             * gradually increase timeout for each of next tries.
             */
            var timeout = connectionAttempts ? 1000 * 15 * connectionAttempts : 1000;
            connectionInterval = $.el8_setTimeout(function() {
              connectionAttempts++;
              el8.appservice.websocket.startWebsocket();
            }, timeout);
          } else {
            el8.appservice.websocket.displayConnectionAlert();

            connectionInterval = $.el8_setTimeout(function() {
              connectionAttempts = 0;
              el8.appservice.websocket.startWebsocket();
            }, FAILED_CONNECTION_TIMEOUT);
          }
        },

        handleWebsocketError: function(event) {
          console.error('WebSocket error has occured', event);
        },

        /**
         * Manage dialogs
         */
        displayConnectionAlert: function() {
          // We don't want to show websocket warning if we lost connection to the main Elation
          // server, because the last one is more important.
          var connectionAlertElt = document.querySelector('#network-status .alertNoInternet');
          if (window.navigator.onLine && !connectionAlertElt && !noConnectionFlag && !noConnectionElt) {
            noConnectionFlag = true;
            noConnectionElt = $(el8.template.service.status.websocketConnectionAlert()).appendTo($('body'));
          }
        },

        hideConnectionAlert: function() {
          if (noConnectionElt && noConnectionFlag) {
            noConnectionFlag = false;
            noConnectionElt.remove();
            noConnectionElt = null;
          }
        }

    };

})();
